export function dropdowns() {
    const dropdown = $(".dropdown");
    const dropOpener = $(".dropdown-opener");

    dropOpener.on("click", function () {
        if (!$(event.target).closest(".external_link").length) {
            let $this = $(this);
            $this.toggleClass("open");
            $this.closest(".dropdown").toggleClass("open");
        }
    });

    $(document).on("click", function (event) {
        if (!$(event.target).closest(".dropdown").length) {
            dropdown.removeClass("open");
            dropOpener.removeClass("open");
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/dropdowns.js